import { addMethod, NumberSchema } from 'yup'

export const emptyNumberAsUndefinedTramsform = () => {
  addMethod(NumberSchema, 'emptyAsUndefined', function emptyAsUndefined() {
    return this.transform(value => (isNaN(Number(value)) ? undefined : Number(value)))
  })
}
